// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const CircleCheck = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 16}
    height={size ?? 16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeLinecap="square" d="M5.5 8.5 7 10l3.5-3.5" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"
    />
  </svg>
);
const ForwardRef = forwardRef(CircleCheck);
export default ForwardRef;
